import {TextInput} from '@primer/react'
import type {ConvertToRulesetPreview} from '../types'

export type PreviewProps = {
  preview: ConvertToRulesetPreview
}

export function Preview({preview}: PreviewProps) {
  const rulesetCount = preview.rulesets.length
  return (
    <div className="d-flex flex-column gap-1">
      <span className="color-fg-muted">
        {rulesetCount} ruleset{rulesetCount !== 1 ? <>s</> : null}
      </span>
      {preview.rulesets.map(ruleset => (
        <TextInput value={ruleset.title} key={ruleset.title} />
      ))}
    </div>
  )
}
